export var BUTTON_GROUP = 'ButtonGroup';